import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {Locale} from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import LocalUS from './en-us'
import LocalZH from './zh-cn'

Vue.use(VueI18n)

const lang = localStorage.getItem('lang')

const i18n = new VueI18n({
  locale: lang ? lang : 'zh',
  messages: {
    'zh': LocalZH,
    'en': LocalUS
  }
})
if (lang === 'en') {
  Locale.use(lang, enUS)
} else {
  Locale.use(lang, zhCN)
}

// en是后缀
Vue.prototype.$t1 = (obj, key) => {
  if (!obj || !i18n) {
    return null
  }
  if (i18n.locale === 'zh') {
    // key -> keyCn -> ''
    return obj[key] && obj[key] !== '' ? obj[key] : (obj[key + 'Cn'] ? obj[key + 'Cn'] : '')
  } else {
    // keyEn -> key -> keyCn -> ''
    return obj[key + 'En'] && obj[key + 'En'] !== '' ? obj[key + 'En'] : (obj[key] && obj[key] !== '' ? obj[key] : (obj[key + 'Cn'] ? obj[key + 'Cn'] : ''))
  }
}

// en是前缀
Vue.prototype.$t2 = (obj, key) => {
  if (!obj || !i18n || !key || key !== '') {
    return null
  }
  if (i18n.locale === 'zh') {
    return obj[key] ? obj[key] : ''
  } else {
    const enKey = 'en' + key.substring(0, 1).toUpperCase() + key.substring(1)
    return obj[enKey] ? obj[enKey] : ''
  }
}

// 给出中文和英文
Vue.prototype.$t3 = (cn, en) => {
  if (!i18n) {
    return null
  }
  if (i18n.locale === 'zh') {
    return cn
  } else {
    return en ? en : cn
  }
}

Vue.prototype.$locale = () => i18n.locale

Vue.prototype.$changeLocale = (lang) => {
  localStorage.setItem('lang', lang)
  i18n.locale = lang
  if (lang === 'en') {
    Locale.use(lang, enUS)
  } else {
    Locale.use(lang, zhCN)
  }
}


export default i18n